import { corePost } from "@/services/coreApi"
import { DEFAULT_EXPORT_FORMAT, routeExportFormat } from "@/config/routeExportFormats"

/**
 * Export a route to file (GeoJSON, Voyage File, or an ECDIS text format).
 *
 * All export logic lives in core (POST /services/route-export). The FE
 * sends the FeatureCollection and desired format; core builds the export
 * payload; the FE triggers the browser download.
 */
export default async function exportRouteToFile({
  fileFormat,
  pathfinderResponse,
  selectedRoute,
  selectedVessel,
  selectedVoyage,
  accessContext,
  setAccessContext,
}) {
  const payload = await corePost(
    "/services/route-export",
    {
      route_payload: pathfinderResponse,
      format: fileFormat,
      vessel_name: selectedVessel?.name ?? null,
      vessel_imo: selectedVessel?.imo || null,
      route_name: selectedRoute || "route",
      voyage_name: selectedVoyage?.name ?? null,
    },
    accessContext,
    setAccessContext,
  )

  const { ext, mime, ecdis } = routeExportFormat(fileFormat) ?? routeExportFormat(DEFAULT_EXPORT_FORMAT)

  let content
  if (ecdis) {
    if (typeof payload !== "string") {
      throw new Error(`Unexpected non-text response for ${fileFormat} export`)
    }
    content = payload
  } else {
    content = JSON.stringify(payload, null, 2)
    if (fileFormat === "voyageFile") {
      content = content.replace(/"true"/g, "'true'")
      content = content.replace(/"false"/g, "'false'")
    }
  }

  const safeName = (selectedRoute || "route").replace(/\s+/g, "_")
  const fileName = `${safeName}.${ext}`

  const blob = new Blob([content], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
